// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".musicianTrackItem_btn__POIDz {\n  color: #464646;\n  border: none;\n  background: inherit;\n  text-transform: uppercase;\n  outline: none;\n  width: 60px; }\n  .musicianTrackItem_btn__POIDz:hover {\n    cursor: pointer; }\n\n.musicianTrackItem_allBtn__2rpD-,\n.musicianTrackItem_musicBtn__16nCz,\n.musicianTrackItem_sfxBtn__iYQiN,\n.musicianTrackItem_dialogBtn__23TZa {\n  font-weight: bold;\n  text-decoration: underline;\n  text-transform: uppercase;\n  outline: none;\n  color: #343b4c;\n  font-size: 14px; }\n  .musicianTrackItem_allBtn__2rpD-:hover,\n  .musicianTrackItem_musicBtn__16nCz:hover,\n  .musicianTrackItem_sfxBtn__iYQiN:hover,\n  .musicianTrackItem_dialogBtn__23TZa:hover {\n    cursor: pointer; }\n", ""]);
// Exports
exports.locals = {
	"btn": "musicianTrackItem_btn__POIDz",
	"allBtn": "musicianTrackItem_allBtn__2rpD-",
	"musicBtn": "musicianTrackItem_musicBtn__16nCz",
	"sfxBtn": "musicianTrackItem_sfxBtn__iYQiN",
	"dialogBtn": "musicianTrackItem_dialogBtn__23TZa"
};
module.exports = exports;
